<template>
    <div class="form-group">
        <label :for="name" class="control-label">{{ label }} <span class="required" v-if="required">*</span></label>
        <input
            :class="classList"
            v-model="data"
            :type="type"
            :name="name"
            :required="required"
            :disabled="disabled"
            :readonly="readonly"
            :autofocus="autofocus"
        />
        <span v-if="invalid" class="invalid-feedback">
            <strong>{{ error }}</strong>
        </span>
    </div>
</template>

<script>
import Errors from '@Core/errors'

export default {

  props: {
    value: {
      //
    },

    name: {
      default: null,
      required: true,
      type: String
    },

    type: {
      default: 'text',
      type: String
    },

    label: {
      default: null
    },

    required: {
      default: false,
      required: false,
      type: Boolean
    },

    disabled: {
      default: false,
      required: false,
      type: Boolean
    },

    autofocus: {
      default: false,
      required: false,
      type: Boolean
    },

    readonly: {
      default: false,
      required: false,
      type: Boolean
    },

    errors: {
      default: () => new Errors(),
      type: Object
    }

  },

  data () {
    return {
      data: this.value,
      validated: false
    }
  },

  computed: {
    classList () {
      return {
        'form-control': true,
        'is-invalid': this.invalid,
        'is-valid': this.validated && !this.invalid
      }
    },

    invalid () {
      return this.errors.has(this.name)
    },

    error () {
      return this.errors.get(this.name)
    }

  },

  watch: {
    data: {
      deept: true,
      handler: function () {
        this.$emit('input', this.data)
      }
    },
    invalid: function (val) {
      if (val) {
        this.validated = true
      }
    }
  }
}
</script>
